import { getAttachmentPath } from "../providers/commons/attachments";
import {
  defaultDarkModeLogo,
  defaultLightModeLogo,
} from "./defaultConfiguration";

/**
 * Logo for signed-out pages. A stored bucket object path cannot be signed
 * without a session, so fall back to the bundled default logo.
 */
export const getAuthPageLogo = (darkModeLogo: string): string =>
  getAttachmentPath(darkModeLogo) != null ? defaultDarkModeLogo : darkModeLogo;

/** Light-mode counterpart of {@link getAuthPageLogo}. */
export const getAuthPageLightLogo = (lightModeLogo: string): string =>
  getAttachmentPath(lightModeLogo) != null
    ? defaultLightModeLogo
    : lightModeLogo;
